class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    const saveButton = this.querySelector('[data-update-note]');
    const noteInput = this.querySelector('.text-area');
    saveButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.savingNote) return;
      this.savingNote = true;
      saveButton.disabled = true;
      const note = noteInput.value;
      const popup = this.closest('.popup-toolDown');
      const saveNote = async () => {
        const response = await fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(), body: JSON.stringify({ note })
        });
        if (!response.ok) throw new Error(window.cartStrings.error);
        const cart = await response.json();
        if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.item_count) ||
            (cart.note == null ? '' : cart.note) !== note) {
          throw new Error(window.cartStrings.error);
        }
        document.querySelectorAll('cart-items textarea[name="note"]').forEach(input => {
          if (input.value === input.defaultValue) {
            input.value = note;
            input.defaultValue = note;
          }
        });
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        return cart;
      };
      const queuedSave = window.Shopify?.queueCartMutation
        ? window.Shopify.queueCartMutation(saveNote)
        : Promise.resolve().then(saveNote);
      const savePromise = queuedSave.then(() => {
        if (this.isConnected && noteInput.value === note && popup?.classList.contains('show')) {
          popup.classList.remove('show');
          const previewCart = this.closest('.previewCart');
          if (!previewCart?.querySelector('.popup-toolDown.show')) {
            previewCart?.classList.remove('active-tool');
          }
        }
        return true;
      }).catch(() => {
        if (typeof showWarning === 'function') showWarning(window.cartStrings.error);
        return false;
      }).finally(() => {
        this.savingNote = false;
        saveButton.disabled = false;
        if (window.Shopify?.cartNoteSavePromise === savePromise) {
          window.Shopify.cartNoteSavePromise = null;
        }
      });
      if (window.Shopify) window.Shopify.cartNoteSavePromise = savePromise;
    });
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    const saveButton = this.querySelector('[data-update-coupon]');
    saveButton.addEventListener('click', async (event) => {
      event.preventDefault();
      if (this.savingCoupon) return;
      this.savingCoupon = true;
      saveButton.disabled = true;
      this.val = this.querySelector('input[name="discount"]').value;
      try {
        const response = await fetch(`/discount/${this.val}`);
        if (!response.ok) throw new Error(window.cartStrings.error);
        await response.text();
        localStorage.setItem('storedDiscount', this.val);
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error(window.cartStrings.error);
        const cart = await cartResponse.json();
        if (!Array.isArray(cart.items)) throw new Error(window.cartStrings.error);
        await window.sharedFunctions?.updateSidebarCart(cart);
        document.querySelector('.popup-toolDown.show')?.classList.remove('show');
        document.querySelector('.previewCart')?.classList.remove('active-tool');
      } catch (error) {
        if (typeof showWarning === 'function') showWarning(window.cartStrings.error);
      } finally {
        this.savingCoupon = false;
        saveButton.disabled = false;
      }
    });
  }
}

customElements.define('coupon-code', CouponCode);